import { useSelector } from 'react-redux';
import type { RootState } from '@/redux/store';

const useSessionUser = () => {
  const { accessToken, user } = useSelector((state: RootState) => state.auth);
  return {
    accessToken,
    user,
    isLoggedIn: Boolean(accessToken),
  };
};

export { useSessionUser };
